import $ from "jquery"
import _ from "underscore"
import {Browser} from './constants'

export function getBodyScrollLeft()
{
    let scrollX = 0;
    if (document.body && !_.isUndefined(document.body.scrollLeft))
    {
        scrollX += document.body.scrollLeft;
        if (document.body.parentNode && document.body.parentNode.scrollLeft && document.body.scrollLeft !== document.body.parentNode.scrollLeft)
        {
            scrollX += document.body.parentNode.scrollLeft;
        }
    }
    else if (window.pageXOffset)
    {
        scrollX += window.pageXOffset;
    }
    return scrollX;
}

export function getBodyScrollTop()
{
    let scrollY = 0;
    if (document.body && !_.isUndefined(document.body.scrollTop))
    {
        scrollY += document.body.scrollTop;
        if (document.body.parentNode && document.body.parentNode.scrollTop && document.body.scrollTop !== document.body.parentNode.scrollTop)
        {
            scrollY += document.body.parentNode.scrollTop;
        }
    }
    else if (window.pageYOffset)
    {
        scrollY += window.pageYOffset;
    }
    return scrollY;
}

/**
 * Disables text selection in the specified element in IE and FF
 * @param element
 * @param dontChangeCursor
 */
export function disableTextSelection(element, dontChangeCursor)
{
    if (!element.aTDisabledSel)
    {
        element.prevOnselectstart = element.onselectstart;
        element.prevOndragstart = element.ondragstart;
        element.prevUnselectable = element.unselectable;
        element.prevMozUserSelect = element.style.MozUserSelect;
        element.prevCursor = element.style.cursor;

        element.onselectstart = () => false;
        element.ondragstart = () => false;
        element.unselectable = "on";
        element.style.MozUserSelect = "none";

        if (!dontChangeCursor)
            element.style.cursor = "default";

        element.aTDisabledSel = true;
    }
}

/**
 * Gets cookie value.
 * Note: return null if cookie not found or cookies disabled.
 *
 * @param name - cookie name
 * @return cookie value
 */
export function getCookie(name)
{
    const cookies = document.cookie.split('; ');
    for (let index = 0; index < cookies.length; index++)
    {
        const nameValPair = cookies[index].split('=');
        if (name === nameValPair[0])
            return nameValPair[1];
    }
    return null;
}

/**
 * Saves value with specified cookie name.
 * Delete cookie if value is null.
 * Note: do nothing if cookies disabled.
 *
 * @param name - cookie name
 * @param value - saving value
 * @param path
 */
export function setCookie(name, value, path)
{
    //current time
    let expireDate = new Date();
    if (value !== null)
    {
        //current time + ~10 years
        expireDate = new Date(expireDate.getTime() + 310000000000);
    }
    document.cookie = [name, "=", value, ";expires=", expireDate.toGMTString(), ( path ) ? ";path=" + path : ""].join("");
}

/**
 * Save array of items in cookie in csv format.
 * If length of csv is larger than max cookie size then first items of array will be exclude from cookie
 * If cookies is disabled do nothing
 * @param arr array
 * @param cookieName name of key in cookie
 */
export function saveArrayIntoCookies(arr, cookieName)
{
    const COUNT_OF_DELETED_ITEMS = 10;

    const arrayStr = arr.join(",");
    setCookie(cookieName, arrayStr);

    // max length of cookie is about 4000 symbols only,
    // therefore should delete old ids to release place for new ids
    const savedValue = getCookie(cookieName);
    if (savedValue && savedValue !== arrayStr)
    {
        arr.splice(0, COUNT_OF_DELETED_ITEMS);
        saveArrayIntoCookies(arr, cookieName);
    }
}

/**
 * Return array of items from cookie(if in cookie it is stored in csv).
 * If cookies is disabled, returns empty array
 * @param cookieName name of key in cookie
 */
export function getArrayFromCookies(cookieName)
{
    const arrayStr = getCookie(cookieName);

    if (arrayStr === null)
        return [];
    else
        return arrayStr.split(",");
}

/**
 * Defines fact that letter or digit symbol is pressed by key code. If event has no key code returns false
 * @param event event
 */
export function isLetterOrDigitSymbolPressed(event)
{
    event = event || window.event;
    const keyCode = event.keyCode;
    if (!keyCode)
        return false;
    return (keyCode > 32) && (keyCode < 91);
}

/**
 * Adds a new class to element's classname. Duplicated classes are ignored.
 * No error checking is performed for input parameters.
 * @param element HTMLElement
 * @param className String
 */
export function addClass(element, className)
{
    if (!hasClass(element, className))
    {
        if (!element.className)
            element.className = "";
        element.className = element.className + " " + className;
    }
}

/**
 * Checks is the element has specified CSS class. No error checking is performed for input parameters.
 * @param element HTMLElement
 * @param className String - CSS class name to check
 */
export function hasClass(element, className)
{
    return element.className && ((' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1);
}

/**
 * Removes the given class from the element.
 * If the element has no class with the given name, then does nothing.
 * @param element HTMLElement
 * @param className String name of the class to remove
 */
export function removeClass(element, className)
{
    replaceClass(element, className, null);
}

/**
 * Replaces one class with another for the given element.
 * If oldClass has not been added to the element, this method has no effect.
 * If newClass is null, undefined or of zero length, old class will just be removed.
 * No error checking is performed for input parameters.
 * @param element HTMLElement.
 * @param oldClass String Old CSS class name.
 * @param newClass String New CSS class name.
 */
export function replaceClass(element, oldClass, newClass)
{
    let newElClassName = (' ' + element.className + ' ');

    if (newClass && (newClass.length > 0))
        newElClassName = newElClassName.replace(' ' + oldClass + ' ', ' ' + newClass + ' ');
    else
        newElClassName = newElClassName.replace(' ' + oldClass + ' ', ' ');

    if (newElClassName.charAt(0) === ' ')
        newElClassName = newElClassName.substr(1);
    if ((newElClassName.length > 0) && (newElClassName.charAt(newElClassName.length - 1) === ' '))
        newElClassName = newElClassName.substr(0, newElClassName.length - 1);

    element.className = newElClassName;
}

export function getEventObj(evt)
{
    let eventObj = null;

    if (typeof evt !== typeof undefined && evt !== null)
        eventObj = evt;
    else if (typeof event !== typeof undefined && event !== null)
        eventObj = event;

    return eventObj;
}

/**
 * Determines whether keyboard button having the specified keyCode has been pressed or not.
 * @return true if keyboard button having the specified keyCode has been pressed and false otherwise.
 */
export function isKeyPressed(keyCode, evt)
{
    const eventObj = getEventObj(evt);

    if (eventObj !== null && eventObj.keyCode === keyCode)
    {
        if (document.all && navigator.userAgent.indexOf("Opera") === -1)
        {
            eventObj.returnValue = false;
        }
        else
        {
            eventObj.preventDefault();
        }

        return true;
    }

    return false;
}

/**
 * Determines whether TAB keyboard button has been pressed or not.
 * @return true if TAB has been pressed and false otherwise.
 */
export function isTabPressed(evt)
{
    return isKeyPressed(9, evt);
}

/**
 * Calls the specified handler if TAB keyboard button has been pressed.
 */
export function handleTab(tabHandler, evt)
{
    if (isTabPressed(evt))
    {
        tabHandler();
    }
}

/**
 * Determines whether ESC keyboard button has been pressed or not.
 * @return true if ESC has been pressed and false otherwise.
 */
export function isEscapePressed(evt)
{
    return isKeyPressed(27, evt);
}

/**
 * Calls the specified handler if ESC keyboard button has been pressed.
 */
export function handleEscape(escHandler, evt)
{
    if (isEscapePressed(evt))
    {
        escHandler(evt);
    }
}

/**
 * Determines whether ENTER keyboard button has been pressed or not.
 * @return true if ENTER has been pressed and false otherwise.
 */
export function isEnterPressed(evt)
{
    return isKeyPressed(13, evt);
}

/**
 * Calls the specified handler if ENTER keyboard button has been pressed.
 */
export function handleEnter(enterHandler, evt)
{
    if (isEnterPressed(evt))
    {
        enterHandler(evt);
    }
}

/**
 * Cancel event bubbling in all browsers
 * @param event action event
 */
export function cancelBubble(event)
{
    event = event || window.event;
    event.cancelBubble = true;
}

export function atImgPath(relativePath)
{
    return window.AT_IMAGE_PATH + "default/" + relativePath + "?hash=" + window.HASH;
}

export function imgPath(relativePath)
{
    return window.IMAGE_PATH + "default/" + relativePath + "?hash=" + window.HASH;
}

export function calculateCoords(event)
{
    let targetEl = event.srcElement;
    if (!targetEl)
        targetEl = event.target;
    return calculateObjectCoords(targetEl);
}

export function calculateObjectCoords(obj)
{
    return {x: findPosX(obj), y: findPosY(obj)};
}

export function findPosX(obj)
{
    let curleft = 0;
    if (obj.offsetParent)
    {
        while (obj.offsetParent)
        {
            curleft += obj.offsetLeft;
            obj = obj.offsetParent;
        }
        curleft += obj.offsetLeft;
    }
    else if (obj.x)
        curleft += obj.x;
    return curleft;
}

export function findPosY(obj)
{
    let curtop = 0;
    if (obj.offsetParent)
    {
        while (obj.offsetParent)
        {
            curtop += obj.offsetTop;
            obj = obj.offsetParent;
        }
        curtop += obj.offsetTop;
    }
    else if (obj.y)
        curtop += obj.y;
    return curtop;
}

export function shiftTo(obj, x, y, isOriginAtBottom)
{
    const units = (typeof obj.style.left === "string") ? "px" : 0;

    obj.style.left = x + units;

    if (isOriginAtBottom)
        obj.style.top = y - getObjectHeight(obj.id) + units;
    else
        obj.style.top = y + units;
}

/**
 * Return client size
 */
export function getClientSize()
{
    return [getInsideWindowWidth() + getBodyScrollLeft(), getInsideWindowHeight() + getBodyScrollTop()];
}

/**
 * Retrieve the rendered width of an element
 * @param objId
 * @return {Number}
 */
export function getObjectWidth(objId)
{
    const elem = document.getElementById(objId);
    let result = 0;
    if (elem.offsetWidth)
        result = elem.offsetWidth;
    else if (elem.clip && elem.clip.width)
        result = elem.clip.width;
    else if (elem.style && elem.style.pixelWidth)
        result = elem.style.pixelWidth;
    return parseInt(result, 10);
}

/**
 * Retrieve the rendered height of an element
 * @param obj_id
 * @return {Number}
 */
export function getObjectHeight(obj_id)
{
    const elem = document.getElementById(obj_id);
    let result = 0;
    if (elem.offsetHeight)
        result = elem.offsetHeight;
    else if (elem.clip && elem.clip.height)
        result = elem.clip.height;
    else if (elem.style && elem.style.pixelHeight)
        result = elem.style.pixelHeight;
    return parseInt(result, 10);
}

/**
 * Return the available content width space in browser window
 * Note: under Firefox, Safari & Opera the scroller width will be included.
 */
export function getInsideWindowWidth()
{
    if (window.innerWidth)
        return window.innerWidth;
    else if (document.documentElement && ( document.documentElement.clientWidth ))
        return document.documentElement.clientWidth;
    else if (document.body && document.body.clientWidth)
        return document.body.clientWidth;
    else if (document.body && document.body.parentElement)
        return document.body.parentElement.clientWidth;
    return 0;
}


/**
 * Return the available content height space in browser window
 * Note: under Safari & Opera the scroller height will be included.
 */
export function getInsideWindowHeight()
{
    if (window.innerHeight)
        return window.innerHeight;
    else if (document.documentElement && ( document.documentElement.clientHeight ))
        return document.documentElement.clientHeight;
    else if (document.body && document.body.clientHeight)
        return document.body.clientHeight;
    else if (document.body && document.body.parentElement)
        return document.body.parentElement.clientHeight;
    return 0;
}

export function getViewport()
{
    const scrollLeft = getBodyScrollLeft();
    const scrollTop = getBodyScrollTop();
    return {
        leftUpperCorner: {x: scrollLeft, y: scrollTop},
        rightBottomCorner: {x: scrollLeft + getInsideWindowWidth(), y: scrollTop + getInsideWindowHeight()}
    }
}

export function scrollToElementIfNeeded(element)
{
    const elementOffsetLeft = findPosX(element);
    const elementOffsetTop = findPosY(element);
    const leftUpperCorner = {x: elementOffsetLeft, y: elementOffsetTop};
    const rightBottomCorner = {x: elementOffsetLeft + element.clientWidth, y: elementOffsetTop + element.clientHeight};
    const viewport = getViewport();
    const viewportLeftUpperCorner = viewport.leftUpperCorner;
    const viewportRightBottomCorner = viewport.rightBottomCorner;

    const spacing = document.body.clientHeight / 3; // to create a space between element and window border
    let scrollY = 0;
    if (rightBottomCorner.y > viewportRightBottomCorner.y)
        scrollY = rightBottomCorner.y + spacing - ( viewportRightBottomCorner.y );
    else if (leftUpperCorner.y < viewportLeftUpperCorner.y)
        scrollY = leftUpperCorner.y - (viewportLeftUpperCorner.y + spacing);
    if (scrollY !== 0)
        window.scrollBy(0, scrollY);
}

export function scrollWindowIfNeeded(object, alignRight)
{
    const $object = $(object);
    const objectOffsetLeft = findPosX(object);
    const objectOffsetTop = findPosY(object);
    const leftUpperCorner = {x: objectOffsetLeft, y: objectOffsetTop};
    const rightBottomCorner = {x: objectOffsetLeft + $object.outerWidth(true), y: objectOffsetTop + $object.outerHeight(true)};
    const viewport = getViewport();
    const viewportLeftUpperCorner = viewport.leftUpperCorner;
    const viewportRightBottomCorner = viewport.rightBottomCorner;

    let scrollX = 0;
    if (leftUpperCorner.x < viewportLeftUpperCorner.x)
    {
        scrollX = leftUpperCorner.x - viewportLeftUpperCorner.x;
    }
    else if (alignRight && rightBottomCorner.x > viewportRightBottomCorner.x)
    {
        scrollX = rightBottomCorner.x - viewportRightBottomCorner.x
    }

    let scrollY = 0;
    if (rightBottomCorner.y > viewportRightBottomCorner.y)
        scrollY = rightBottomCorner.y - viewportRightBottomCorner.y;

    if (scrollX !== 0 || scrollY !== 0)
    {
        /*alert("VIEWPORT\ntop-left.x = " + viewportLeftUpperCorner.x + ", top-left.y = " + viewportLeftUpperCorner.y +
              "; bottom-right.x = " + viewportRightBottomCorner.x + ", bottom-right.y = " + viewportRightBottomCorner.y + "\n\n" +
              "object\ntop-left.x = " + leftUpperCorner.x + ", top-left.y = " + leftUpperCorner.y +
              "; bottom-right.x = " + rightBottomCorner.x + ", bottom-right.y = " + rightBottomCorner.y + "\n\n" +
              "SCROLL BY\nscrollX = " + scrollX + ", scrollY = " + scrollY);*/
        window.scrollBy(scrollX, scrollY);
    }
}

/**
 * Smoothly scrolls the window down so that the needed element is fully visible.
 * Only scrolls down, doesn't scroll up even if the element is not visible.
 * Requires jQuery.
 *
 * @param element element to scroll to (either an element, selector or jQuery object)
 * @param [offset] how many pixels should be between the element bottom and the window bottom. Default is 0.
 * @param [duration] how long the animation will take. If not specified, then jQuery default is used.
 */
export function smoothlyScrollDownToElement(element, offset, duration)
{
    element = $(element);

    if (_.isUndefined(offset))
        offset = 0;

    const initialScrollTop = $(document).scrollTop();
    const scrollTopChange = Math.max(0, -initialScrollTop + element.offset().top + element.outerHeight() - $(window).height() + offset);

    $("body,html").animate({scrollTop: initialScrollTop + scrollTopChange}, duration);

    // Although we can use scrollTop() method on $(document), animate() doesn't work on it.
    // Instead, we use animate() on body and html elements (some browsers require body and some html).
}

export function isMSIE()
{
    // This is the same logic as in RequestUtil.isIEUserAgent.
    // If you change here, be sure to also change there.
    return navigator.userAgent.indexOf("Trident") !== -1;
}

export function isIE8()
{
    return navigator.userAgent.toLowerCase().indexOf("msie 8") > -1;
}

/**
 * Show jQuery element at position with positionParams.
 * If part of the element is shown outside left or top border of the document, try to fix it by changing collision parameter
 */
export function showElementAt(element, positionParams)
{
    let pos = {};
    pos.of = positionParams.of;
    pos.my = positionParams.my ? positionParams.my : "left top";
    pos.at = positionParams.at ? positionParams.at : "left bottom";
    pos.offset = positionParams.offset;
    let col = ( positionParams.collision ? positionParams.collision : "flip" ).split(" ");
    pos.horCollision = col[0];
    pos.vertCollision = col[col.length - 1];

    pos.collision = pos.horCollision + " " + pos.vertCollision;

    pos.within = positionParams.within ? positionParams.within : $(window)
    element.position(pos);

    const offset = element.offset();
    if ((offset.left < 0 && pos.horCollision !== "none") || (offset.top < 0 && pos.vertCollision !== "none"))
    {
        if (offset.left < 0) pos.horCollision = "none";
        if (offset.top < 0) pos.vertCollision = "none";

        pos.collision = pos.horCollision + " " + pos.vertCollision;
        element.position(pos);
    }
}

/**
 * Subscribes element to outside click event.
 * @param $el Element.
 * @param eventNamespace Click event namespace to prevent unwanted unsubscribing.
 * @param clickHandler Click handler.
 * @param ignoreEventPredicate Custom ignore predicate, when it returns true, click handler doesn't trigger.
 * @param $outsideContainer outside element, where outside clicks are handled. Default value - document body
 *
 * @returns string registered event name
 */
export function onOutsideClick($el, eventNamespace, clickHandler, ignoreEventPredicate, $outsideContainer)
{
    const eventName = "click." + eventNamespace;
    if (!$outsideContainer)
        $outsideContainer = $(document);
    $outsideContainer.off(eventName).on(eventName, e =>
    {
        if (ignoreEventPredicate(e) ||
            e.target === document.body ||
            $el.is(e.target) ||
            $el.has(e.target).length > 0)
            return;

        clickHandler(e);
    });

    return eventName
}

export const registerOnClickOutside = ($el,
        eventNamespace,
        clickHandler,
        ignoreEventPredicate = () => false,
        $outsideContainer = $(document)) => {

    const eName = onOutsideClick($el, eventNamespace, clickHandler, ignoreEventPredicate, $outsideContainer)
    return () => {
        $outsideContainer.off(eName)
    }
}
/**
 * Fixes wheel event for elements, which are located inside iScroll containers.
 * @param $el Inner element with native scroll.
 */
export function fixIScrollInnerWheelEvent($el)
{
    $el.on("wheel mousewheel DOMMouseScroll", e =>
    {
        const el = $el[0];
        if (el.clientHeight < el.scrollHeight)
            e.stopPropagation();
    });
}

/**
 * Sets the handler for clicking outside an element.
 * Requires jQuery.
 *
 * TODO: there must be a way to unset the handler. This function should store the actual handler (not the given one,
 *       but the one which is dynamically created and attached to the document mousedown) in the given elements data()
 *       property. This would allow the creation of the 'unsetMouseDownOutsideHandler' function, which would get the
 *       actual handler from the element's data() and unset it from the document.
 *
 * TODO: seems that this handler is actually for clicking outside the _children_ of the element.
 *       So if I click inside the element but outside any of its children, the handler won't be executed.
 *
 * @param element - an element, selector or jQuery object
 * @param handler - function
 */
export function setMouseDownOutsideHandler(element, handler)
{
    element = $(element);

    $(document).mousedown(function(event)
    {
        if ($(event.target).parents().index(element) === -1)
        {
            handler(event);
        }
    });
}

export function calculateTooltipOffset(tooltip, event, bottomBarHeight)
{
    return calculateTooltipOffsetByItParameters(tooltip.getHeight(), tooltip.getWidth(), event, bottomBarHeight);
}

export function calculateElementOffset(height, width, event, bottomBarHeight)
{
    return calculateTooltipOffsetByItParameters(height, width, event, bottomBarHeight);
}

export function calculateTooltipOffsetByItParameters(tooltipHeight, tooltipWidth, event, bottomBarHeight)
{
    const bottomBarHeightValue = bottomBarHeight ? bottomBarHeight : 0;
    let top = event.pageY + 5;
    if (top + tooltipHeight + bottomBarHeightValue - getBodyScrollTop() > $(window).height())
        top -= tooltipHeight;
    let left = event.pageX + 15;
    if (left + tooltipWidth - getBodyScrollLeft() > $(window).width())
        left -= tooltipWidth + 22;
    return {top: top, left: left};
}

export function doOnceOn(element, actionName, callback)
{
    const handler = function()
    {
        callback();
        $(element).off(actionName, handler);
    };
    $(element).on(actionName, handler);
    return function() {$(element).off(actionName, handler)};
}

export function doOnceOnWindowResize(callback)
{
    return doOnceOn(window, "resize", callback);
}

/**
 * Determines which mouse button was pressed.
 * @param event - the event object from the onmousedown event handler (it may work in some other events, too)
 */
export function whichButtonPressed(event)
{
    if (event.which === null) {
        // IE case
        return (event.button < 2) ? "left" : ((event.button === 4) ? "middle" : "right");
    }
    else {
        // All others
        return (event.which < 2) ? "left" : ((event.which === 2) ? "middle" : "right");
    }
}

/**
 * Prevent event in all browsers
 * @param event action event
 */
export function preventDefault(event)
{
    event = event || window.event;
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
}

export function setFocusIntoFieldWithPlaceholder( field ) {
    if( !isMSIE() ) // IE hides placeholder on focus, so we don't autofocus in IE
        $( field ).focus();
}

export function scrollToElementInPopup(scrollableContainer, element)
{
    const popupOffset = scrollableContainer.offset().top;
    const popupHeight = scrollableContainer.height();
    const windowScroll = $(window).scrollTop();
    const windowFullHeight = window.innerHeight + windowScroll;

    const elementHeight = element.height();
    const marginTop = element.position().top;
    const marginBottom = popupHeight - marginTop - elementHeight;

    //container fully visible in window frame.
    if (popupOffset > windowScroll && popupHeight + popupOffset < windowFullHeight)
    {
        //element is not fully visible in container
        if (marginTop < 0 || marginBottom < 0)
        {
            const scrollPosition = scrollableContainer.scrollTop();
            scrollableContainer.scrollTop(scrollPosition + marginTop);
        }
    }
    else
    {
        const elementTopOffset = marginTop + popupOffset;

        //element is not fully visible in window
        if (elementTopOffset < windowScroll || elementTopOffset + elementHeight > windowFullHeight )
        {
            //double scroll to element.
            element[0].scrollIntoView(true);
        }
    }
}

export function enableTextSelectionBack(element)
{
    if( element.aTDisabledSel )
    {
        element.onselectstart = element.prevOnselectstart;
        element.ondragstart = element.prevOndragstart;
        element.unselectable = element.prevUnselectable;
        element.style.MozUserSelect = element.prevMozUserSelect;
        element.style.cursor = element.prevCursor;
        element.aTDisabledSel = false;
    }
}

export function createElement(tagName) {
    return document.createElement(tagName);
}

export function createElementWithProperties(tagName, properties) {
    const element = createElement(tagName);
    for (let key in properties) {
        assign(element, key, properties[key]);
    }
    return element;
}

export function assign(obj, compositeKey, value) {
    const keyParts = compositeKey.split(".");
    const lastKeyIndex = keyParts.length - 1;
    for (let i = 0; i < lastKeyIndex; i++) {
        const key = keyParts[i];
        if (!(key in obj)) {
            obj[key] = {};
        }
        obj = obj[key];
    }
    obj[keyParts[lastKeyIndex]] = value;
}

export function checkAncestorHasClass(node, className) {
    let nextParent = node.parentNode
    while (nextParent && nextParent !== document) {
        if (nextParent.classList.contains(className)) {
            return true
        }
        nextParent = nextParent.parentNode
    }
    return false
}

export function checkElementOrAncestorHasClass(element, className) {
    return element.classList.contains(className) || checkAncestorHasClass(element, className)
}

/**
 * Copy text to clipboard via creating temporary input
 * @param text for copy
 * @param onCopy callback after copy
 */
export const copyToClipboard = (text, onCopy = () => {}) => {
    const input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    const result = document.execCommand('copy');
    document.body.removeChild(input)
    onCopy(result)
}

/**
 * Converts size to CSS pixel size string (for example, 15 to "15px")
 * @param size Size in pixels.
 */
export function px(size) {
    return size + 'px'
}

/**
 * Determines which browser is used
 */
export function getBrowser() {
    let sUsrAg = navigator.userAgent.toLowerCase()

    //The order matters here, and this may report false positives for unlisted browsers.
    if (sUsrAg.indexOf("firefox") > -1) {
        return Browser.FIREFOX
    } else if (sUsrAg.indexOf("opera") > -1) {
        return Browser.OPERA
    } else if (sUsrAg.indexOf("trident") > -1) {
        return Browser.IE
    } else if (sUsrAg.indexOf("edge") > -1 || sUsrAg.indexOf("edg") > -1) {
        return Browser.EDGE
    } else if (sUsrAg.indexOf("chrome") > -1) {
        return Browser.CHROME
    } else if (sUsrAg.indexOf("safari") > -1) {
        return Browser.SAFARI
    } else {
        return Browser.OTHER
    }
}



// WEBPACK FOOTER //
// ./web/js/atBrowserUtils.js